import {Graphics} from 'pixi.js';
import {CoreDI, DisplayObjectUtils, inject, ScreenParameters} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {View} from '@gongxigames/framework/slot';

const SHAKE_SKRIN_OFFSET = 200;
const SHAKE_SKRIN_OFFSET2 = SHAKE_SKRIN_OFFSET * 2;

export class GameFrameView extends View {
    public static readonly NAME: symbol = Symbol('GameFrameView');
    public static layer = LAYERS.TOP;

    @inject(CoreDI.DisplayObjectUtils)
    protected _displayObjectUtils!: DisplayObjectUtils;

    protected _faderTop!: Graphics;
    protected _faderBottom!: Graphics;
    protected _faderRight!: Graphics;
    protected _faderLeft!: Graphics;

    public init(): void {
        super.init();

        this._faderTop = this._displayObjectUtils.createFader(1, 1, 1);
        this._faderBottom = this._displayObjectUtils.createFader(1, 1, 1);
        this._faderRight = this._displayObjectUtils.createFader(1, 1, 1);
        this._faderLeft = this._displayObjectUtils.createFader(1, 1, 1);

        this.container.addChild(this._faderTop, this._faderBottom, this._faderRight, this._faderLeft);
    }

    public onResized(screenParams: ScreenParameters): void {
        const {x, y, width, height, scale} = screenParams;
        const {ceil} = Math;
        const canvasWidth = x / scale * 2 + width;
        const canvasHeight = y / scale * 2 + height;
        const paddingY = y / scale;
        const paddingX = x / scale;

        this._faderTop.width = canvasWidth + SHAKE_SKRIN_OFFSET2;
        this._faderTop.height = ceil(paddingY) + SHAKE_SKRIN_OFFSET;
        this._faderTop.x = -paddingX - SHAKE_SKRIN_OFFSET;
        this._faderTop.y = -paddingY - SHAKE_SKRIN_OFFSET;

        this._faderBottom.width = canvasWidth + SHAKE_SKRIN_OFFSET2;
        this._faderBottom.height = ceil(paddingY) + SHAKE_SKRIN_OFFSET;
        this._faderBottom.y = height;
        this._faderBottom.x = -paddingX - SHAKE_SKRIN_OFFSET;

        this._faderLeft.height = canvasHeight + SHAKE_SKRIN_OFFSET2;
        this._faderLeft.width = ceil(paddingX) + SHAKE_SKRIN_OFFSET;
        this._faderLeft.x = -paddingX - SHAKE_SKRIN_OFFSET;
        this._faderLeft.y = -paddingY - SHAKE_SKRIN_OFFSET;

        this._faderRight.height = canvasHeight + SHAKE_SKRIN_OFFSET2;
        this._faderRight.width = ceil(paddingX) + SHAKE_SKRIN_OFFSET;
        this._faderRight.x = width;
        this._faderRight.y = -paddingY - SHAKE_SKRIN_OFFSET;
    }
}
